<template>
    <div class="installt">
        <div class="intext">运营场次管理</div>
        <div class="addpopers">
            <div class="addpoper" @click="openDialog">
                <div> <el-icon :size="24" color="#fff">
                        <Plus style=" margin-right: 8px" />
                    </el-icon></div>
                <div style="height: 24px;">添加场次</div>

            </div>

        </div>

    </div>
    <div class="goodsort">
        <div class="goodlei">
            <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
                <el-tab-pane :label="'秒杀活动'" name="first">
                    <Slasher @totallist="totallist"></Slasher>
                </el-tab-pane>

            </el-tabs>
        </div>

    </div>
    <el-dialog v-model="dialogTableVisible" title="编辑活动" width="478">
        <div class="dialog">

            <div>活动名称</div>
            <div class="dialogname">
                <input type="text" v-model="dialogname" placeholder="请填写秒杀活动名称">
            </div>
            <div>指定时间</div>
            <div style="margin-top: 11px;">
                <el-date-picker style=" height: 48px;background-color: #FAFAFA;" v-model="gettime" type="datetimerange"
                    start-placeholder="开始时间" end-placeholder="结束时间" @change="chnagetime" />
            </div>

            <div class="changchuang" @click="changis">
                创建场次
            </div>
        </div>

    </el-dialog>
</template>

<script setup>
import Slasher from '@/components/event/Slasher.vue';

import { ref, onMounted } from 'vue'
import api from '@/api/api'
import stores from '@/api/store';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'
const router = useRouter()
const activeName = ref('first')
let totallists = ref(0)
const dialogTableVisible = ref(false)
const totallist = (val) => {
    // console.log('totallist',val)
    totallists.value = val
}
const handleClick = (tab, event) => {
    console.log(tab, event)
}
let gettime = ref(null)
let setTime = null
let endTime = null
let dialogname = ref(null)
const changis = async () => {
    if (dialogname.value == null) {
        ElMessage({
            message: '请输入活动名称！',
            type: 'warning',
        })
    } else if (!setTime && !endTime) {
        ElMessage({
            message: '请选择时间！',
            type: 'warning',
        })
    } else {
        let data = {
            venueSlogan: dialogname.value,
            beginTime: setTime,
            finishTime: endTime
        }
        const res = await stores.Venuesave(data)
        if (res.success) {
            ElMessage({
                message: '添加活动成功',
                type: 'success',
                onClose:()=>{
                    dialogTableVisible.value = false
                    
                }
            })
        } else {
            ElMessage.error(res.message)
        }
    }
}
const chnagetime = (e) => {
    console.log(e[1], gettime.value)
    setTime = getimess(e[0])
    endTime = getimess(e[1])
}

let getimess = (time) => {
    const dateObj = new Date(time);

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
//助花商品列表
let goodslist = ref([])
let wordKey = ref('')
const goodadd = () => {
    router.push('/home/goodlist/goodadd')
}
const openDialog = () => {
    dialogTableVisible.value = true
}
onMounted(() => {

})
</script>

<style lang="scss" scoped>
::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #F8F8F8 !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

}

.dialog {
    font-weight: 400;
    font-size: 14px;
    color: #718096;

    .dialogname {
        width: 100%;
        height: 56px;
        background: #FAFAFA;
        padding-top: 20px;
        box-sizing: border-box;
        border-radius: 8px;
        margin-top: 12px;
        margin-bottom: 36px;

    }

    .changchuang {
        width: 398px;
        height: 49px;
        background: #2979FF;
        border-radius: 10px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 56px;
        margin: 70px auto 40px;
        cursor: pointer;
    }
}

.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 32px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpopers {
        display: flex;

        .addpoper {
            width: 132px;
            height: 48px;
            background: rgba(63, 140, 255);
            box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
            border-radius: 8px;
            color: #FFFFFF;
            cursor: pointer;
            padding-left: 16px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin-left: 33px;
        }
    }

}

.goodsort {
    position: relative;
    margin-top: 22px;
    height: calc(100% - 50px - 32px);
    background-color: #fff;
    border-radius: 8px;

    .goodlei {
        height: 100%;
    }


}

::v-deep .demo-tabs {
    height: 100%;

    .el-tabs__header {
        margin-bottom: 0;
    }

    .el-tabs__content {
        height: calc(100% - 60px);
    }

    .el-tabs__nav-scroll {

        .el-tabs__nav {

            .el-tabs__item {
                height: 60px !important;
                margin-right: 61px;
            }
        }
    }

    #tab-first {
        margin-left: 24px !important;
    }
}
</style>